window.toastr = require('toastr');

// configuration de toastr
toastr.options = {
    "closeButton": true,
    "debug": false,
    "newestOnTop": false,
    "progressBar": true,
    "positionClass": "toast-bottom-right",
    "preventDuplicates": false,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
}


// displayNotif({type:'info', body:'test', href:'https://www.google.fr'})

// displayNotif({type:'info', body:'test', href:'https://www.google.fr'})
/**
 * @function Fonction pour afficher une notification
 * @param params object Objet contenant le paramettre de la notification
 *     - type info, success, danger, error (default: info)
 *     - title : titre de la notification
 *     - body : texte de la notification
 *     - href : lien de la notification
 *     - options : options de toastr
 */
window.displayNotif = function(params) {

    var type = params.type || 'info';
    var body = params.body || null;
    var title = params.title || null;
    var options = params.options || {};
    var href = params.href || null;

    if (body != null || title != null)
    {
        console.log({
            type: type,
            body: body,
            title: title,
            options: options
        })
        // toastr[type](body, title, options);

        window.toastr.info(body, title, options).click(function(e){
            console.log('console href', params.href, href );
            if (href != null)
            {
                window.location.href = href;
            }
        });
    }
};


/*
window.displayNotif

toastr.info('body text 1', 'header text',
    {onclick: function() {console.log('you clicked on the info toaster n.1')}}
);
*/
